import React from 'react'
import { FormattedMessage } from 'react-intl'

import { AdultsPickerModeEnum } from './adults-picker.enum'
import {
  ISearchBarPicker,
  SearchBarPicker,
} from '../../atoms/fields/search-bar-picker/search-bar-picker'
import { SearchBarPickerModeEnum } from '../../atoms/fields/search-bar-picker/search-bar-picker.enum'
import Icon from '../../atoms/icons/icon'
import { TravelTypeEnum } from '../../../lib/graphql'
import { cn } from '../../../shadcn/utils'

type AdultsSearchBarPickerProps = {
  mode: AdultsPickerModeEnum
  revampPicker: boolean
  fieldValue?: number
  isMobile: boolean
  travelType: TravelTypeEnum
  className: string
  isAdultsSelected: boolean
}

const getFormattedValue = (revampPicker: boolean, value?: number) => {
  if (!value) {
    return null
  }

  if (revampPicker) {
    return (
      <FormattedMessage
        id='ui.indexAdultPicker.value.adultsSearch.revamp'
        defaultMessage='{travellers} {travellers, plural, one {participant} other {participants}}'
        values={{ travellers: value }}
      />
    )
  }

  return (
    <FormattedMessage
      id='ui.indexAdultPicker.value.adultsSearch'
      defaultMessage='{travellers} {travellers, plural, one {adulte} other {adultes}}'
      values={{ travellers: value }}
    />
  )
}

const getPlaceholder = ({
  mode,
  revampPicker,
  travelType,
}: {
  mode: AdultsPickerModeEnum
  revampPicker: boolean
  travelType: TravelTypeEnum
}) => {
  if (mode !== AdultsPickerModeEnum.HOUSE_SEARCH) {
    return (
      <FormattedMessage
        id='ui.indexAdultPicker.label.adultsSearch.howMany'
        defaultMessage='Combien ?'
      />
    )
  }

  if (revampPicker) {
    return (
      <FormattedMessage
        id='ui.AdultsPicker.revamp.placeholder'
        defaultMessage='Participants'
      />
    )
  }

  if (travelType === TravelTypeEnum.CORPORATE_EVENING_EVENT) {
    return (
      <FormattedMessage
        id='ui.AdultsPicker.corporateEveningEvent.placeholder'
        defaultMessage='Participants ?'
      />
    )
  }

  return (
    <FormattedMessage
      id='ui.indexAdultPicker.placeholder.adultsSearch'
      defaultMessage='Voyageurs ?'
    />
  )
}

const getLabel = (revampPicker: boolean, mode: AdultsPickerModeEnum) => {
  if (mode === AdultsPickerModeEnum.HOUSE_SEARCH) {
    return null
  }

  if (revampPicker) {
    return (
      <FormattedMessage
        id='ui.AdultsPicker.revamp.label'
        defaultMessage='Participants'
      />
    )
  }

  return (
    <FormattedMessage
      id='ui.indexAdultPicker.label.adultsSearch.travellers'
      defaultMessage='Voyageurs'
    />
  )
}

export const AdultsSearchBarPicker: React.FC<AdultsSearchBarPickerProps> = ({
  mode,
  revampPicker,
  fieldValue,
  isMobile,
  travelType,
  className,
  isAdultsSelected,
}) => {
  const isHouseSearchMode = mode === AdultsPickerModeEnum.HOUSE_SEARCH

  const searchBarPickerProps: ISearchBarPicker = {
    placeholder: getPlaceholder({ mode, revampPicker, travelType }),
    value: getFormattedValue(revampPicker, fieldValue),
    isMobile,
    alternativeClassName: className,
    label: getLabel(revampPicker, mode),
    mode: isHouseSearchMode ? SearchBarPickerModeEnum.HOUSE_SEARCH : undefined,
  }

  return (
    <>
      {isHouseSearchMode && (
        <>
          {revampPicker && fieldValue ? null : (
            <div
              className={cn(isAdultsSelected ? 'text-black' : 'text-grey-600')}
            >
              <Icon
                name='user-filled'
                size={20}
                className='transition-colors'
              />
            </div>
          )}
        </>
      )}
      <SearchBarPicker {...searchBarPickerProps} />
    </>
  )
}
